import React, { } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  List,
  Row,
  Col,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import commonComponents from "../../../components/common";
import accountComponents from "./components/index";

const SettingsAccount = () => {
  const { PageHeader } = commonComponents;
  const { PersonalInfo, Preferences, DangerZone } = accountComponents;
  const { t } = useTranslation();

  return (
    <div className="account-details layout-content">
      <PageHeader
        title={t('account_details.title')}
        subtitle={t('account_details.description')}
        actions={[]}
      />
      <List
        itemLayout="horizontal"
        className="mt-2"
        dataSource={
          [
            {
              key: 'personal_info',
              title: t('account_details.personal_info'),
            },
            {
              key: 'preferences',
              title: t('account_details.preferences.title')
            },
            {
              key: 'danger_zone',
              title: t('account_details.danger_zone.title')
            },
          ]
        }
        renderItem={(item, index) => (
          <List.Item>
            <Row className="w-full">
              <Col lg={8} md={8} sm={24} xs={24}>
                <p className="text-lg font-semibold mb-2">
                  {item.title}
                </p>
              </Col>
              <Col lg={16} md={16} sm={24} xs={24}>
                {
                  index === 0 && <PersonalInfo />
                }
                {
                  index === 1 && <Preferences />
                }
                {
                  index === 2 && <DangerZone />
                }
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </div>
  );
}

export default SettingsAccount;